import * as React from 'react';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { PhoneConfirmationContainer } from '../../PhoneConfirmationV2Container';

const image = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-desk-4.png';
const imageMobile = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-mob-4.jpg';

export const RequestFormPhoneVerificationContainer = () => {
  return (
    <FormCardLayout
      dataTestId="RequestFormV2PhoneVerification"
      question="Введите код из смс"
      image={image}
      imageMobile={imageMobile}
    >
      <PhoneConfirmationContainer />
    </FormCardLayout>
  );
};
